import * as React from "react";
import { Router, Route, Switch } from "react-router-dom";
import "./components/theme/less/theme.less";
import { GlobalProvider } from "./services/provider/Global.provider";
import createHistory from "history/createBrowserHistory";
import { LocaleProvider } from "antd";
import pt_BR from "antd/lib/locale-provider/pt_BR";
import "src/components/theme/scss/common.scss";
import { LoadStaticScripts } from "./StaticScripts";
import { Suspense, lazy } from "react";
import Loading from "src/components/common/Loading";
import "./App.css";
import { ServiceProvider } from "./services/provider/Service.provider";
import { SecureProvider } from "./services/provider/Secure.provider";
import { MenuUrlEnum } from "./layout/side-menu/MenuUrlEnum";
import ConfigService from "./services/config/config.service";

const Admin = lazy(() => import("./pages/Routers"));

const history = createHistory();
LoadStaticScripts(history);

const App = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path={MenuUrlEnum.BaseUrl} component={Admin} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default (props: any) => (
  <>



    <script src={`https://www.google.com/recaptcha/api.js?render=${ConfigService.getConfig().gRecaptcha}`} />
    <LocaleProvider locale={pt_BR}>
      <ServiceProvider>
        <SecureProvider>
          <GlobalProvider>
            <App {...props} />
          </GlobalProvider>
        </SecureProvider>
      </ServiceProvider>
    </LocaleProvider>
  </>
);



// WEBPACK FOOTER //
// ./src/App.tsx